import React from 'react';

const AudiencesSection = () => {
  return (
    <section className="audiences bg-white py-[90px] px-[5%]" id="for-you">
      <div className="text-center max-w-[860px] mx-auto">
        <div className="section-label text-[0.78rem] font-bold uppercase tracking-[0.08em] text-blue-500 mb-3">
          Built for Both Sides
        </div>
        <h2 className="section-title text-[clamp(1.6rem,3.5vw,2.4rem)] font-black leading-tight mb-4 text-slate-900">
          Whether you're placing deals
          <br />
          or funding them
        </h2>
      </div>
      <div className="audience-grid grid md:grid-cols-2 gap-[28px] mt-[56px] text-left">
        <div className="audience-card rounded-[16px] p-[44px] relative overflow-hidden bg-gradient-to-br from-slate-900 to-slate-800 text-white">
          <div className="audience-tag inline-block bg-white/15 border border-white/25 rounded-full px-[14px] py-1 text-[0.75rem] font-bold uppercase tracking-[0.06em] mb-5 text-white/90">
            For Brokers
          </div>
          <h3 className="text-[1.5rem] font-black mb-[12px] leading-tight">Close more deals without the operational chaos</h3>
          <p className="text-[0.95rem] opacity-80 leading-[1.7] mb-[28px]">
            Stop spending your time on admin. The Business Lending Hub gives you a structured system to manage every client and deal — so you can focus on what you do best.
          </p>
          <ul className="audience-list space-y-[10px] m-0 p-0 list-none">
            <li className="flex items-start gap-[10px] text-[0.9rem] opacity-90">
              <span className="font-bold opacity-70 flex-shrink-0">→</span>
              Full client and lead management in one place
            </li>
            <li className="flex items-start gap-[10px] text-[0.9rem] opacity-90">
              <span className="font-bold opacity-70 flex-shrink-0">→</span>
              Submission-ready loan package builder
            </li>
            <li className="flex items-start gap-[10px] text-[0.9rem] opacity-90">
              <span className="font-bold opacity-70 flex-shrink-0">→</span>
              Real-time pipeline tracking from lead to close
            </li>
            <li className="flex items-start gap-[10px] text-[0.9rem] opacity-90">
              <span className="font-bold opacity-70 flex-shrink-0">→</span>
              Lender matching to stop guessing and start submitting
            </li>
            <li className="flex items-start gap-[10px] text-[0.9rem] opacity-90">
              <span className="font-bold opacity-70 flex-shrink-0">→</span>
              Document collection that actually works
            </li>
          </ul>
        </div>
        <div className="audience-card rounded-[16px] p-[44px] relative overflow-hidden bg-gradient-to-br from-indigo-600 to-blue-500 text-white">
          <div className="audience-tag inline-block bg-white/15 border border-white/25 rounded-full px-[14px] py-1 text-[0.75rem] font-bold uppercase tracking-[0.06em] mb-5 text-white/90">
            For Lenders
          </div>
          <h3 className="text-[1.5rem] font-black mb-[12px] leading-tight">Receive better packages and fund more deals</h3>
          <p className="text-[0.95rem] opacity-80 leading-[1.7] mb-[28px]">
            Work with brokers who use a structured, professional process. Get the information you need, organized the way you want it — and maintain visibility into submissions.
          </p>
          <ul className="audience-list space-y-[10px] m-0 p-0 list-none">
            <li className="flex items-start gap-[10px] text-[0.9rem] opacity-90">
              <span className="font-bold opacity-70 flex-shrink-0">→</span>
              Receive clean, complete loan packages from brokers
            </li>
            <li className="flex items-start gap-[10px] text-[0.9rem] opacity-90">
              <span className="font-bold opacity-70 flex-shrink-0">→</span>
              Track submissions and deal status in real time
            </li>
            <li className="flex items-start gap-[10px] text-[0.9rem] opacity-90">
              <span className="font-bold opacity-70 flex-shrink-0">→</span>
              Structured broker profiles and deal history
            </li>
            <li className="flex items-start gap-[10px] text-[0.9rem] opacity-90">
              <span className="font-bold opacity-70 flex-shrink-0">→</span>
              Direct communication channel with broker teams
            </li>
            <li className="flex items-start gap-[10px] text-[0.9rem] opacity-90">
              <span className="font-bold opacity-70 flex-shrink-0">→</span>
              Fewer back-and-forth requests for missing info
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AudiencesSection;
